export function payload(jwt) {
  return jwt && decode(split(jwt)[1]);
}

function split(jwt) {
  return jwt.split(".", 3); // header.payload.signature
}

function decode(part) {
  return JSON.parse(window.atob(part));
}